
import React, { useContext, useState, useEffect } from 'react';
import AppContext from '../context/app/appContext';

import PerfectScrollbar from 'react-perfect-scrollbar'

const FilterTag = ({ ident, title }) => {

    const appContext = useContext(AppContext);
    const [searchText, setSearchText] = useState('');
    const [options, setOptions] = useState([]);

    const ENTER_KEY = 13;

    const expandToggle = (event) => {
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            appContext.toggleActiveFilter(ident);
            //console.log(ident);
        }
    }

    const optionToggle = (event, optionIdent) => {
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            //console.log(ident, optionIdent);
            appContext.toggleSelectedOption({ filterIdent: ident, optionIdent: optionIdent });
        }
    }

    const handleChange = (event) => {
        const value = event.target.value;

        setSearchText(value);
    }

    const handleKeyDown = (event) => {
        if (event.keyCode === ENTER_KEY) {
        }
    }


    useEffect(() => {
        var ops = [];
        Object.keys(appContext.dictionaries[ident])
            .filter(keyName => { 
                if ( appContext.dictionaries[ident][keyName] !== null ) {
                    return appContext.dictionaries[ident][keyName].toLowerCase().indexOf(searchText.toLowerCase()) >= 0 
                }
                return false
            })
            .map((optionKeyName, i) => {
                if ( appContext.dictionaries[ident][optionKeyName] !== null ) {
                    ops.push({ key: optionKeyName, name: appContext.dictionaries[ident][optionKeyName] });
                }
            }
            )

        ops.sort((a, b) => a.name.localeCompare(b.name));

        setOptions(ops);
    }, [searchText]);


    return (
        <li className="filter-tag">
            <a className={appContext.activeFilters.indexOf(ident) >= 0 ? 'trigger selected' : 'trigger'} onClick={(event) => expandToggle(event)} onKeyDown={(event) => expandToggle(event)} href="#">{title}</a>
            <div className="expandable">
                <div className="search-me">
                    <input
                        placeholder="Type to search"
                        type="search"
                        name="gs"
                        onChange={(event) => handleChange(event)}
                        onKeyDown={(event) => handleKeyDown(event)}
                    />
                </div>
                <div className="scroll-me">
                    <PerfectScrollbar options={{ suppressScrollX: true, wheelSpeed: 1, wheelPropagation: false }}  >
                        <ul className="options-menu">

                            {options.map((option, i) => {
                                const { key, name } = option;
                                let enabledClass = appContext.availableDictionaries[ident][key] === true ? 'enabled' : 'disabled';
                                return (

                                    <li
                                        key={key}
                                        className={(appContext.activeOptions[ident] && appContext.activeOptions[ident].indexOf(key) >= 0) ? enabledClass + ' selected' : enabledClass}
                                    >
                                        <a
                                            href="#"
                                            onClick={(event) => optionToggle(event, key)}
                                            onKeyDown={(event) => optionToggle(event, key)}
                                        >{name}</a>
                                    </li>
                                )
                            })}
                        </ul>
                    </PerfectScrollbar>
                </div>
            </div>
        </li >
    );
}

export default FilterTag;